import { gql } from "@apollo/client";

export const GET_NOTIFICATIONS = gql`
  query GetNotifications($userId: ID!, $read: Boolean, $category: String) {
    notifications(userId: $userId, read: $read, category: $category) {
      id
      userId
      type
      category
      title
      message
      data
      read
      createdAt
    }
  }
`;

export const GET_UNREAD_NOTIFICATIONS_COUNT = gql`
  query GetUnreadNotificationsCount($userId: ID!) {
    unreadNotifications(userId: $userId)
  }
`;

export const GET_NOTIFICATION = gql`
  query GetNotification($id: ID!) {
    notification(id: $id) {
      id
      userId
      type
      category
      title
      message
      data
      read
      createdAt
    }
  }
`;
